// eslint-disable-next-line no-restricted-imports
import { useColorScheme as useMuiColorScheme } from '@mui/material/styles';

type UseColorScheme = ReturnType<typeof useMuiColorScheme> & {
  isDarkMode: boolean;
};

// Wrapper around MUI's useColorScheme so we can easily determine if we are in dark mode or not
export const useColorScheme = (): UseColorScheme => {
  const colorScheme = useMuiColorScheme();

  const isDarkMode =
    colorScheme.mode === 'dark' ||
    (colorScheme.mode === 'system' && colorScheme.systemMode === 'dark');

  return {
    ...colorScheme,
    isDarkMode,
  };
};
